import { render, staticRenderFns } from "./searchResults.vue?vue&type=template&id=42ed5f9a"
import script from "./searchResults.vue?vue&type=script&lang=js"
export * from "./searchResults.vue?vue&type=script&lang=js"
import style0 from "./searchResults.vue?vue&type=style&index=0&id=42ed5f9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports